import { useState, useEffect } from "react"

type Breakpoint = "sm" | "md" | "mmd" | "lg" | "xl"

const breakpoints: Record<Breakpoint, number> = {
  sm: 640,
  md: 768,
  mmd: 920,
  lg: 1024,
  xl: 1280,
}

interface ScreensizeOptions {
  min?: Breakpoint | null
  max?: Breakpoint | null
}

function useScreensize({
  min = null,
  max = null,
}: ScreensizeOptions = {}): boolean {
  const [shouldRender, setShouldRender] = useState<boolean>(true)

  useEffect(() => {
    if (typeof window === "undefined") return

    const query = [
      min ? `(min-width: ${breakpoints[min]}px)` : "",
      max ? `(max-width: ${breakpoints[max] - 1}px)` : "",
    ]
      .filter(Boolean)
      .join(" and ")

    if (!query) {
      setShouldRender(true)
      return
    }

    const media = window.matchMedia(query)
    setShouldRender(media.matches)

    const listener = (e: MediaQueryListEvent) => setShouldRender(e.matches)
    media.addEventListener("change", listener)

    return () => media.removeEventListener("change", listener)
  }, [min, max])

  return shouldRender
}

export default useScreensize
